import { useCallback } from 'react';

/**
 * Hook that returns a callback function to be used as a ref.
 * When the ref is attached to an element, it checks the `shouldScroll` condition.
 * If `shouldScroll` is true, it scrolls into the view of the element smoothly.
 * The scroll is activated not only when the element mounts, but also whenever the `shouldScroll` condition changes to true.
 *
 * @param {boolean} [shouldScroll] - Condition to determine whether to scroll to the element or not.
 * @returns {Function} Callback function to be used as a ref.
 */
export function useConditionalScrollTo(shouldScroll?: boolean) {
  const scrollTo = useCallback(
    (element: HTMLElement | null) => {
      if (shouldScroll && element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    [shouldScroll]
  );

  return scrollTo;
}
